import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Table, Icon, Segment, Loader, Dimmer } from "semantic-ui-react";
import { connect } from "react-redux";
import genericAction from "@Actions/generic";
import IKModal from "@Components/IkModal";

const ContactInfoModal = ({ open, onClose, contact, dispatch }) => {
	const [contactData, setContactData] = useState(null);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (open && (contact?.contactId || contact?.id)) {
			fetchContactData();
		}
	}, [open, contact]);

	const formatDate = (date) => {
		if (!date) return "";

		return new Date(date).toLocaleString("es-DO", {
			day: "2-digit",
			month: "2-digit",
			year: "numeric",
			hour: "2-digit",
			minute: "2-digit",
			hour12: true,
		});
	};

	const fetchContactData = async () => {
		setLoading(true);
		try {
			const id = contact?.contactId || contact?.id;
			await dispatch(
				genericAction({
					method: "get",
					route: `contacts/${id}`,
					onSuccess: (response) => {
						setContactData(response.data);
					},
				})
			);
		} catch (error) {
			// error
		} finally {
			setLoading(false);
		}
	};

	const renderField = (label, value, icon = "tag") => {
		if (value === null || value === undefined || value === "") return null;
		return (
			<Table.Row key={label}>
				<Table.Cell collapsing style={{ fontWeight: "bold", width: "35%" }}>
					<Icon name={icon} size="small" style={{ marginRight: "5px" }} />
					{label}
				</Table.Cell>
				<Table.Cell>{String(value)}</Table.Cell>
			</Table.Row>
		);
	};

	return (
		<IKModal title="Información del Contacto" onClose={onClose} size="tiny" mode="Watch" hideEditButton>
			{loading ? (
				<Dimmer active inverted>
					<Loader />
				</Dimmer>
			) : contactData ? (
				<Table basic="very" celled striped style={{ width: "100%" }}>
					<Table.Body>
						<div style={{ backgroundColor: "#fff", padding: "10px", borderRadius: "5px" }}>
							{renderField("ID", contactData.contactId, "hashtag")}
							{renderField("Nombre", contactData.name, "user")}
							{renderField("Teléfono", contactData.phone, "phone")}
							{renderField("Email", contactData.email, "mail")}
							{renderField("Bloqueado", contactData.isBlocked ? "Sí" : "No", "ban")}
							{renderField("Canal", contactData.contact?.channel, "comments")}
							{renderField("Último Agente", contactData.lastAgent.fullName, "user outline")}
							{renderField("Fecha Último Cierre", formatDate(contactData.lastCloseDate), "calendar")}
						</div>
					</Table.Body>
				</Table>
			) : (
				<Segment placeholder textAlign="center">
					<Icon name="info circle" size="large" />
					<p>No se encontró información del contacto.</p>
				</Segment>
			)}
		</IKModal>
	);
};

ContactInfoModal.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
	contact: PropTypes.object,
	dispatch: PropTypes.func,
};

export default connect()(ContactInfoModal);
